@if (participants.length) {
    @for (participant of participants; track participant; let index = $index) {
        <li class="greyhound-result-list">
            <div class="greyhound-result-participants">
                <div class="participant-left">
                    <span class="greyhounds-caption-text" [class.caption-style]="placeTermValue && index < placeTermValue">
                        {{ getParticipantCaption(participant) }}
                    </span>
                    <span class="resulted-distance-desc">{{ participant.racingPostInfo?.greyhoundsData.resultedRpDistanceDescription }}</span>
                    <ms-gh-trap-images
                        [greyhoundTrapDogMapping]="greyhoundTrapDogMapping"
                        [isOptionBet]="isOptionBet"
                        [participant]="participant"></ms-gh-trap-images>
                    <div class="greyhounds-box">
                        <span class="greyhounds-participant-name">
                            @if (isOptionBet) {
                                {{ this.greyhoundTrapDogMapping[participant.participantId].greyhoundName }}
                            } @else {
                                {{ participant.properties!.greyhound || (participant.name | msTranslate) }}
                            }
                        </span>
                        @if (participant.properties?.trainer) {
                            <span class="greyhound-trainer-name-prefix">
                                {{ sitecore.horseRacing.common.TrainerNamePrefix }}
                                <span>{{ participant.properties?.trainer }}</span>
                            </span>
                        }
                    </div>
                </div>
                <div class="participant-right">
                    @if (isOptionBet) {
                        <span class="participant-odds greyhounds-participant-odds">{{
                            getParticipantOption(participant.id) | msExternalPriceFormatter
                        }}</span>
                    } @else if (!isOptionBet && prices[participant.id]) {
                        <span class="participant-odds greyhounds-participant-odds">{{
                            prices[participant.id]!.price | msExternalPriceFormatter
                        }}</span>
                    }
                </div>
            </div>
        </li>
    }
}
